export class TaskDestroyedException extends Error {}
